module.exports = __webpack_public_path__ + "static/media/change.ba6e7931.svg";